/**
 * 로그인 (/m/login — 장비불러 앱, 리뉴얼 화면 signup/loginV2) — 비밀번호 보기·자동로그인·아이디 하이픈·ajax 로그인
 * ($j.Pages.Mobile.LoginV2 / body data-page-name="LoginV2")
 */
export default class LoginV2 {
    initialize() {
        // 다른 기기에 자리를 내주고 밀려나 왔다 (DeviceSlotService::kickOut) — #page-data
        const kicked = JSON.parse(document.getElementById('page-data')?.textContent || '{}').kickedNotice;
        if (kicked) $j.Common.Util.swalert(kicked);

        let busy = false;

        $(function () {
            initPassword();
            initAutoLogin();
            initPhoneFormat();
            initSubmit();

            // 뒤로가기로 페이지가 캐시 복원되면 전송중 표시가 남아 버튼이 먹통이 된다
            window.addEventListener('pageshow', function (e) {
                if (e.persisted) { busy = false; $('#lg-submit').removeClass('is-loading'); }
            });
        });

        function initPassword() {
            $('.sg-eye').on('click', function () {
                const $inp = $(this).siblings('input');
                const show = $inp.attr('type') === 'password';
                $inp.attr('type', show ? 'text' : 'password');
                $(this).attr({ 'aria-pressed': String(show), 'aria-label': show ? '비밀번호 숨기기' : '비밀번호 보기' });
            });
        }

        function initAutoLogin() {
            const $box = $('#lg-auto');
            function toggle() {
                const on = $box.attr('aria-checked') !== 'true';
                $box.attr('aria-checked', String(on)).toggleClass('is-on', on);
                $('#remember').val(on ? '1' : '');
            }
            $box.on('click', toggle).on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
            });
        }

        /**
         * 아이디는 휴대폰 번호다 — 치는 대로 대시를 넣어 준다.
         * 전역 phoneNumber() 를 쓰지 않는 이유: 아이디는 번호보다 뒷자리가 길 수 있는데
         * (같은 번호로 재가입한 회원 — 예: 010-3773-620401) 전역 함수는 8자리에서 잘라 버린다.
         */
        function initPhoneFormat() {
            $('#mem_id').on('input', function () {
                if (!this.value.startsWith('01')) return;
                const at = this.selectionStart === this.value.length;   // 끝에서 치는 중인가
                this.value = formatIdPhone(this.value);
                if (at) { try { this.setSelectionRange(this.value.length, this.value.length); } catch (e) {} }
            });
        }

        function formatIdPhone(value) {
            const v = String(value || '').replace(/[^0-9]/g, '');
            if (!v) return '';
            const rest = v.substring(3);
            const mid = rest.length === 7 ? 3 : 4;   // 3-3-4 / 3-4-나머지
            return [v.substring(0, 3), rest.substring(0, mid), rest.substring(mid)].filter(Boolean).join('-');
        }

        function initSubmit() {
            $('.lg-sns__btn').on('click', function () {
                $j.F.Social.login(this.dataset.sns);
            });

            $('#loginform').on('submit', function (e) {
                e.preventDefault();
                login();
            });
        }

        /** 입력값 검사 — 서버(LoginService)도 4자 미만을 막지만, 왕복 한 번을 아낀다 */
        function validate() {
            const id = $('#mem_id').val().trim();
            const pw = $('#mem_pwd').val();
            let ok = true;

            setErr('mem_id', !id ? '휴대폰 번호를 입력해 주세요.'
                : id.replace(/[^0-9]/g, '').length < 4 ? '휴대폰 번호를 끝까지 입력해 주세요.' : '');
            setErr('mem_pwd', !pw ? '비밀번호를 입력해 주세요.'
                : pw.length < 4 ? '비밀번호는 4자 이상이에요.' : '');

            $('.sg-err').each(function () { if (this.textContent) ok = false; });
            return ok;
        }

        function setErr(name, msg) {
            $('#err-' + name).text(msg);
            $('#' + name).toggleClass('is-error', !!msg);
        }

        function login() {
            if (busy || !validate()) return;
            busy = true;
            $('#lg-submit').addClass('is-loading');

            $.ajax({
                type: 'POST',
                url: '/m/ajax/login',
                data: $('#loginform').serialize(),
            })
                .done(function (data) {
                    if (data.message) { $j.Common.Util.swalert(data.message); return; }
                    location.replace(data.url);
                })
                .fail(function () {
                    $j.Common.Util.swalert('로그인 중 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.');
                })
                .always(function () {
                    busy = false;
                    $('#lg-submit').removeClass('is-loading');
                });
        }
    }
}
